module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AmEa2P/tc-custom/9781504094917.jpg?1730581085887",
      "alt": "This image is the cover for the book Perfect Couple"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Perfect Couple\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Their life looks so perfect on the surface. But the facade is beginning to crack . . .")]), _c('br'), _c('br'), _vm._v(" Nevin and Gloria both have successful careers, as well as two adorable kids and a picture-book cottage by the sea. But at forty, Nevin is experiencing some discontent. He’s a successful author, but his latest plot is not for a book . . ."), _c('br'), _c('br'), _vm._v(" As Nevin sets a plan in motion that will allow him to escape his marriage, he conspires against Gloria. But he should have thought it through a little more. Because each of them have their own agenda, and everything is about to go very wrong."), _c('br'), _c('br'), _vm._v(" There’s no such thing as a perfect marriage—or a perfect crime . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      N.J. Cracknell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0